import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { usePagination } from '../hooks/usePagination';
import { useUserBorrowsContent } from '../hooks/useUserBorrowsContent';

import { Store } from '@/shared/store';
import { BorrowStatusType, History, MaintenanceData } from '@/shared/api/borrow';
import { ButtonGroup } from '@/shared/ui';
import { useHasBorrowError } from '@/shared/hooks/useErrors';
import { useMarginAccountsContext } from '@/app/providers';

const STEP = 9;

const borrowStatusList = [
    {
        text: 'Opened',
        value: BorrowStatusType.OPENED,
    },
    {
        text: 'On Hold',
        value: BorrowStatusType.SUSPENDED,
    },
    {
        text: 'Closed',
        value: BorrowStatusType.CLOSED,
    },
];

export type UserBorrowItem = {
    address: string;
    id: number;
    apy: string;
    leverageAddress: string;
    name: string;
    symbol: string;
    decimals: number;
    amount: string;
    openedAt: string;
    maintenance: MaintenanceData;
    history: History<MaintenanceData>[];
    agreementAddress: string;
};

export const UserBorrowsSection: FC = () => {
    const { walletAddress, marginAccount } = useSelector((state: Store) => ({
        walletAddress: state.wallets.active?.address,
        marginAccount: state.wallets.walletConnect?.connectedDapp?.marginAccount,
    }));

    const {
        items,
        callUserBorrows,
        selectedBorrowStatusList,
        handleSelectedBorrowStatusListChange,
    } = useMarginAccountsContext();

    const { page, setPage, totalPages } = usePagination(items, STEP);

    const hasError = useHasBorrowError();

    useEffect(() => {
        callUserBorrows();
    }, [callUserBorrows]);

    const content = useUserBorrowsContent(
        walletAddress,
        items,
        selectedBorrowStatusList,
        page,
        setPage,
        totalPages,
        STEP,
        marginAccount,
        hasError,
    );

    return (
        <div className='mt-9'>
            {walletAddress && (
                <div className='flex justify-between items-center mb-8 '>
                    <div className='text-lg pl-5 font-semibold'>My Positions</div>
                    <ButtonGroup
                        items={borrowStatusList}
                        value={selectedBorrowStatusList}
                        handleChange={handleSelectedBorrowStatusListChange}
                        className='
                        w-fit min-w-[295px] [&_button]:font-semibold
                        [&>label]:flex [&>label]:font-semibold [&>label]:justify-center [&>label]:items-center [&>label]:flex-[1_0_0] 
                        '
                    />
                </div>
            )}

            {content}
        </div>
    );
};
